import { createMonotonicNow, } from './_internal/create_monotonic_now';
/**
 * This function returns the `DOMHighResTimeStamp` that can be used to calculate
 * duration measurement. It using `performance.now()` if exists, or fallback to
 * `Date.now()` otherwise.
 *
 * When `performance.now()` is used, the timestamps returned are not limited to
 * one-millisecond resolution. Instead, they represent times as floating-point
 * numbers with up to microsecond precision.
 *
 * @returns Timestamp in milliseconds.
 */
export const monotonicNow = createMonotonicNow(() => performance.now(), Date.now);
/**
 * Calculate the duration between two monotonic timestamps.
 *
 * The result is rounded to the nearest millisecond.
 *
 * Using this function instead of `end - start` can be useful to ensure that the
 * reported duration is an integer number of milliseconds and that both
 * timestamps are created using the `monotonicNow()` function. It will also
 * protect against accidentally passing the arguments in the wrong order.
 *
 * The overhead of calling this function is negligible when measuring IO
 * latency.
 *
 * @param start - The start timestamp created by calling `monotonicNow()`.
 * @param end - The end timestamp created by calling `monotonicNow()`. If not
 *   provided, the current time is used by calling `monotonicNow()`.
 * @returns The duration in milliseconds.
 */
export const monotonicDuration = (start, end = monotonicNow()) => Math.round(Math.abs(end - start));
//# sourceMappingURL=monotonic_now.js.map